module.exports = __webpack_public_path__ + "img/basique.cb4cdf8c.png";